<template>
    <div style="background-color: #f5f5f5; overflow: hidden; margin-top: 0.7rem">
        <div class="uploadDataBox">
            <div style="font-size: 16px; color: #333333; margin-bottom: 12px">
                发票信息
            </div>
            <div class="invoice_information">
                <div>
                    <div>发票内容：</div>
                    <div>信息技术服务费</div>
                </div>
                <div>
                    <div>开票方：</div>
                    <div>山西星卫视传媒有限公司</div>
                    <!-- <div>{{ ruleForm.sellerName }}</div> -->
                </div>
                <div>
                    <div>开票金额：</div>
                    <div>{{ ruleForm.price }}元</div>
                </div>
                <div>
                    <div>发票类型：</div>
                    <div>增值税电子普通发票</div>
                </div>
            </div>
        </div>

        <div class="uploadDataBox">
            <div style="font-size: 16px; color: #333333; margin-bottom: 12px">
                请填写发票抬头
            </div>
            <el-form ref="ruleFormRef" :model="ruleForm" label-width="100px" :rules="rules" class="demo-ruleForm"
                :size="formSize" status-icon label-position="left">
                <el-form-item label="发票类型" prop="type">
                    <el-radio-group v-model="ruleForm.type" class="ml-4" @change="changeType">
                        <el-radio :label="1" size="small">企业</el-radio>
                        <el-radio :label="2" size="small">个人</el-radio>
                        <el-radio :label="3" size="small">非企业单位（政府机关、事业单位、军队、学校等非营利性组织）</el-radio>
                    </el-radio-group>
                </el-form-item>

                <div v-if="ruleForm.type == 1 || ruleForm.type == 3">
                    <el-form-item label="发票抬头" prop="header">
                        <el-input v-model="ruleForm.header" placeholder="请输入发票抬头" />
                    </el-form-item>
                    <el-form-item label="企业税号" v-if="ruleForm.type == 1" prop="dutyParagraph1">
                        <el-input v-model="ruleForm.dutyParagraph1" placeholder="请输入企业税号" />
                    </el-form-item>
                    <el-form-item label="企业税号" v-if="ruleForm.type == 3" prop="dutyParagraph2">
                        <el-input v-model="ruleForm.dutyParagraph2" placeholder="请输入企业税号" />
                    </el-form-item>
                    <el-form-item label="注册地址" prop="address">
                        <el-input v-model="ruleForm.address" placeholder="请输入注册地址" />
                    </el-form-item>
                    <el-form-item label="注册电话" prop="phone">
                        <el-input v-model="ruleForm.phone" placeholder="请输入注册电话" />
                    </el-form-item>
                    <el-form-item label="开户银行" prop="openBank">
                        <el-input v-model="ruleForm.openBank" placeholder="请输入开户银行" />
                    </el-form-item>
                    <el-form-item label="银行账号" prop="bankAccount">
                        <el-input v-model="ruleForm.bankAccount" placeholder="请输入银行账号" />
                    </el-form-item>
                </div>
                <div v-if="ruleForm.type == 2">
                    <el-form-item label="发票抬头" prop="header">
                        <el-input v-model="ruleForm.header" placeholder="请输入需要开具发票的姓名" />
                    </el-form-item>
                    <el-form-item label="手机号" prop="phone"
                        :rules="[{ required: true, message: '请输入手机号', trigger: 'blur' }]">
                        <el-input v-model="ruleForm.phone" placeholder="请输入手机号" />
                    </el-form-item>
                </div>
            </el-form>
        </div>

        <div class="uploadDataBox">
            <div style="font-size: 16px; color: #333333; margin-bottom: 12px">
                请填写电子邮箱
            </div>
            <el-form ref="ruleFormRef" :model="ruleForm" label-width="100px" :rules="rules" class="demo-ruleForm"
                :size="formSize" status-icon label-position="left">
                <el-form-item label="电子邮箱" prop="email">
                    <el-input v-model="ruleForm.email" placeholder="请输入电子邮箱" />
                </el-form-item>
            </el-form>
        </div>
        <div style="width: 80%; margin: 0 auto;cursor: pointer;">
            <div class="dataBtn" @click="onSubmit">提交</div>
        </div>
    </div>
</template>

<script  setup>
import { reactive, ref } from "vue";
import { Axios } from "@/assets/js/ls_com_axios.js";
import { useRoute, useRouter } from "vue-router";
import { ElTable, ElMessage } from "element-plus";
const urlData = new URLSearchParams(location.search);
const router = useRouter();
const formSize = ref("default");
const ruleFormRef = ref();
const changeType = (val) => {
    ruleForm.value = {
        price: "",
        header: "",
        dutyParagraph: "",
        email: "",
        address: '',
        phone: "",
        openBank: '',
        bankAccount: '',
        email: "",
        type: Number(val)
    };
}
// do not use same name with ref
let ruleForm = ref({
    type: 1,
    price: "",
    header: "",
    dutyParagraph: "",
    email: "",
    address: '',
    phone: "",
    openBank: '',
    bankAccount: '',
    email: ""
});
const rules = reactive({
    type: [
        {
            required: true,
            message: "请选择内容",
            trigger: "blur",
        },
    ],
    header: [
        {
            required: true,
            message: "请输入内容",
            trigger: "blur",
        },
    ],
    dutyParagraph1: [
        {
            required: true,
            message: "请输入内容",
            trigger: "blur",
        },
    ],
    email: [
        {
            required: true,
            message: "请输入内容",
            trigger: "blur",
        },
    ],
});
const detailData = ref({});
const getList = () => {
    Axios(
        "get",
        "/system/courseWeb/catalogue",
        {
            courseId: urlData.get('id')
        },
        false,
        (res) => {
            ruleForm.value.price = res.data.data.price;
            () => {
                detailData.value = {};
            }
        })
}
getList()
//保存发票
const onSubmit = () => {
    if (!ruleForm.value.type) {
        ElMessage({
            message: "请选择发票类型",
            type: "warning",
        });
        return;
    }

    if (ruleForm.value.type == 1) {
        if (!ruleForm.value.header) {
            ElMessage({
                message: "请输入发票抬头",
                type: "warning",
            });
            return;
        }
    }
    if (ruleForm.value.type == 2) {
        if (!ruleForm.value.header) {
            ElMessage({
                message: "请输入需要开具发票的姓名",
                type: "warning",
            });
            return;
        }
        if (!ruleForm.value.phone) {
            ElMessage({
                message: "请输入手机号",
                type: "warning",
            });
            return;
        }
    }
    if (ruleForm.value.type == 3) {
        if (!ruleForm.value.header) {
            ElMessage({
                message: "请输入发票抬头",
                type: "warning",
            });
            return;
        }
    }
    if (!ruleForm.value.email) {
        ElMessage({
            message: "请输入电子邮箱",
            type: "warning",
        });
        return;
    }
    Axios(
        "post",
        "/system/courseWeb/applyInvoice",
        {
            courseId: urlData.get('id'),
            orderNo: urlData.get('o'),
            type: ruleForm.value.type,
            header: ruleForm.value.header,
            dutyParagraph: ruleForm.value.dutyParagraph,
            address: ruleForm.value.address,
            phone: ruleForm.value.phone,
            openBank: ruleForm.value.openBank,
            bankAccount: ruleForm.value.bankAccount,
            price: ruleForm.value.price,
            email: ruleForm.value.email,
        },
        false,
        (res) => {
            if (res.data.code == 200) {
                ElMessage({
                    message: "提交成功",
                    type: "success",
                });
                router.back();
            }
        }, () => {
            ElMessage({
                message: '提交失败',
                type: "warning",
            });
        })
};
</script>

<style scoped>
.invoice_information {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}

.invoice_information>div {
    display: flex;
    width: 300px;
    margin-bottom: 0.13rem;
}

.invoice_information>div:nth-child(2n) {
    width: calc(100% - 300px);
}

.invoice_information>div:last-child {
    width: calc(100% - 300px);
    margin-bottom: 0rem;
}

.invoice_information>div>div:first-child {
    font-size: 14px;
    color: #86909c;
}

.invoice_information>div>div:last-child {
    font-size: 14px;
    color: #333333;
}

.uploadDataBox {
    /* width: 10.8rem; */
    width: 80%;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: 0.3rem auto 0.3rem;
    padding: 0.36rem 0.8rem;
}

.sliderBox {
    border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
    background: #f5f5f5;
    padding: 0.24rem 0.24rem 0.32rem;
    box-sizing: border-box;
    margin: 0.16rem 0 0.24rem;
}

.upload-demo {
    width: 7.02rem;
}

.dataBtn {
    width: 2.68rem;
    padding: 0.12rem 1.06rem;
    background: #c01a26;
    border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
    opacity: 1;
    text-align: center;
    font-size: 0.14rem;
    color: #fff;
    margin-bottom: 0.18rem;
    cursor: pointer;
}

.other {
    background: rgba(255, 96, 0, 0.2);
    border-radius: 0.28rem;
    opacity: 1;
    font-size: 0.14rem;
    color: #ff6000;
    padding: 0.1rem;
}

/deep/.el-form-item__label {
    /* width: 1.7rem!important; */
    color: #333333 !important;
    text-align: left !important;
}

/deep/.el-form-item--default {
    font-size: 0.14rem !important;
}
</style>
